import styled from "styled-components";
import { FlexContainer,ScrollableContainer } from "../../components/styled";
import ProgressBar from "../../components/shared/progressBar";
import DeckCard from "../../components/shared/deckCard";
import UpgradeSeperator from "../../assets/images/upgradeSeperator.png";
import { PrimaryButton } from "../../components/styled";
import { useCryptidSelectModal } from "../../hooks/useCryptidSelectModal";
import { useUpgradeResultModal } from "../../hooks/useUpgradeResultModal";
import { useState } from "react";
import { useLoading } from "../../context/LoadingContext";
import { useEffect } from "react";
import { getTransactionStatus } from "../../service/main/api";
import { useNavigate } from "react-router-dom";
// import { useWalletContext } from "../../context/WalletContext";
import { useBottomSheet } from "../../context/BottomSheetContext";
import SelectInventoryItemModalContent from "../../components/SelectInventoryItemModalConten";
import { getInventory } from "../../service/main/api";
import { upgradeCard } from "../../service/main/api";
import { useToaster } from "../../hooks/useToaster";
import { pulseRight } from "../../components/styled/animations";


const Upgrader = (props) => {
    const {cards,calculateUpgradeDetails} = props
    const {setIsLoading} = useLoading();
    const [targetCard,setTargetCard] = useState(null);
    const [selectableCards,setSelectableCards] = useState([]);
    const [materialCards,setMaterialCards] = useState([]);
    const [successRate,setSuccessRate] = useState(0);
    const [cost,setCost] = useState(0);
    const [roi,setRoi] = useState(0);
    const MaterialCards = Array(4).fill(0).map((_,i) => <DeckCard card={materialCards[i]} clickAction={()=>openCryptidSelectModal(selectableCards,onCardSelected, true, materialCards, 4)} containerStyle={{maxWidth:"66px"}} key={i} />);
    const {openCryptidSelectModal,closeCryptidSelectModal} = useCryptidSelectModal();
    const {openUpgradeResultModal} = useUpgradeResultModal();
    const [destinationAddress, setDestinationAddress] = useState("");
    const [transaction,setTransaction] = useState(null);
    const depositAddress = process.env.REACT_APP_JETTON_WALLET_ADDRESS || "";
    const [transactionConfirmed, setTransactionConfirmed] = useState(false);
    const {walletDetails,tonConnectUI} = {};
    const navigate = useNavigate();
    const {openSheet,closeSheet} = useBottomSheet();
    const [selectedEnhancer,setSelectedEnhancer] = useState(null);
    const [enhancers,setEnhancers] = useState([]);
    const { showToaster } = useToaster();

    const onCardSelected = (cards) => {
      if(!targetCard){
        alert("Please select target card first");
        return;
      }
        // if(materialCards.find(c=>c._id === card._id)){
        //   alert("You can't select same card twice");
        //   return;
        // }
        if(cards.some((item) => item?._id === targetCard?._id)){
          alert("You can't select target card as material card");
          return;
        }

        // switch (targetCard.rarity.name) {
        //   case "Normal":
        //     if(card.rarity.name !== "Normal"){
        //       alert("You can use only normal cards as material for normal cards");
        //       return;
        //     }
        //     break;
        //   case "Rare":
        //     if(card.rarity.name !== "Normal"){
        //       alert("You can use only normal cards as material for Rare cards");
        //       return;
        //     }
        //     break;
        //   case "Unique":
        //     if(card.rarity.name !== "Rare"){
        //       alert("You can use only rare cards as material for Unique cards");
        //       return;
        //     }
        //     break;
        //   case "Legend":
        //     if(card.rarity.name !== "Unique"){
        //       alert("You can use only unique cards as material for Legend cards");
        //       return;
        //     }
        //     break;
        //   case "Mythic":
        //     if(card.rarity.name !== "Legend"){
        //       alert("You can use only legend cards as material for Mythic cards");
        //       return;
        //     }
        //     break;

        //   default:
        //     break;
        // }

        switch (targetCard.rarity.name) {
          case "Normal":
            if(cards.some((item) => item?.rarity?.name !== "Normal")){
              alert("You can use only normal cards as material for normal cards");
              return;
            }
            break;
          case "Rare":
            if(cards.some((item) => item?.rarity?.name !== "Normal")){
              alert("You can use only normal cards as material for Rare cards");
              return;
            }
            break;
          case "Unique":
            if(cards.some((item) => item?.rarity?.name !== "Rare")){
              alert("You can use only rare cards as material for Unique cards");
              return;
            }
            break;
          case "Legend":
            if(cards.some((item) => item?.rarity?.name !== "Unique")){
              alert("You can use only unique cards as material for Legend cards");
              return;
            }
            break;
          case "Mythic":
            if(cards.some((item) => item?.rarity?.name !== "Legend")){
              alert("You can use only legend cards as material for Mythic cards");
              return;
            }
            break;

          default:
            break;
        }

        closeCryptidSelectModal();
        setMaterialCards(cards);
    }
    const onTargetCardSelect = (card) => {
      try {
        if(materialCards.find(c=>c._id === card._id)){
          alert("You can't select target card in material cards");
          return;
        }
        if(card.level.value === 5){
          alert("You can't upgrade a card which is already at max level");
          return;
        }
        setTargetCard(card);
        setMaterialCards([]);
        setSelectableCards([]);
        switch (card.rarity.name) {
          case "Normal":
            setSelectableCards(cards.filter(c=>c.rarity.name === "Normal"));
            break;
          case "Rare":
            setSelectableCards(cards.filter(c=>c.rarity.name === "Normal"));
            break;
          case "Unique":
            setSelectableCards(cards.filter(c=>c.rarity.name === "Rare"));
            break;
          case "Legend":
            setSelectableCards(cards.filter(c=>c.rarity.name === "Unique"));
            break;
          case "Mythic":
            setSelectableCards(cards.filter(c=>c.rarity.name === "Legend"));
            break;
          default:
            break;
        }

        const {cost,successRate,roi} = calculateUpgradeDetails(card);
        setCost(cost);
        setSuccessRate(successRate);
        setRoi(roi);
        closeCryptidSelectModal();
      } catch (error) {
        console.log(error)
        alert("An error occured while selecting target card",error);
      }
    }
    const handleUpgrade = async () => {
      try {
        if(!targetCard){
          alert("Please select target card");
          return;
        }
        if(materialCards.length < 4){
          alert("Please select 4 material cards");
          return;
        }
        const materialCardIds = materialCards.map(c=>c._id);
        setIsLoading(true);
        const res = await upgradeCard({targetCard:targetCard._id,materialCards:materialCardIds,enhancer:selectedEnhancer._id});
        if(res?.success){
          showToaster({type:"success",message:"Upgrade transaction is successful"});
               let isSuccessful = res.data.upgradedCard ? true : false;
                    let cryptid = isSuccessful ? {
                      name:res.data.upgradedCard.card.name,
                      level:{value:res.data.upgradedCard.level.value},
                      type:res.data.upgradedCard.card.cryptidType,
                      rarity:res.data.upgradedCard.card.rarity,
                      weakness:res.data.upgradedCard.card.weaknessType,
                      miningPower:res.data.upgradedCard.miningPower,
                      imageUri:res.data.upgradedCard.card.imageUri
                    } : targetCard;
                    openUpgradeResultModal(cryptid,isSuccessful);
                    getEnhancers();
                    setSelectedEnhancer(null);
                    setMaterialCards([]);
                    setTargetCard(null);
          setIsLoading(false);

        }else{
          setIsLoading(false);
          showToaster({type:"error",message:res.messages});
        }
      } catch (error) {
        setIsLoading(false);
        showToaster({type:"error",message:"Something went wrong while upgrading card"});
        setTargetCard(null);
        setMaterialCards([]);
        setSelectedEnhancer(null);
      }

        // openSelectItemModal();
      //   const res = await createUpgradeTransaction({targetCard:targetCard._id,materialCards:materialCardIds});
      //  if(res?.success){
      //   try {
      //      setTransaction(res.data);
      //   } catch (error) {
      //     console.log(error);
      //   }
      //  }else{
      //    alert(res.messages);
      //  }

    }
    const checkTransactionStatus = async () => {
        if(transaction?.invoiceId){
        const response = await getTransactionStatus(transaction.invoiceId);
        if(response?.success){
          setTransaction(response.data);
          if(response.data.status === "success"){
            return response.data;
          }
          return "pending";
        }else{
            return "failed";
        }
        }
    }

    // const startPolling = (interval = 2000, maxTry = 30) => {
    //     let attempts = 0;
    //     const pollingInterval = setInterval(async () => {
    //         attempts++;
    //         try {
    //             const res = await checkTransactionStatus();
    //             if (res !== "failed" && res !== "pending") {
    //               console.log(res);
    //                 let tx = res
    //                 setIsLoading(false);
    //                 clearInterval(pollingInterval);
    //                 let isSuccessful = tx.details.upgradedCard ? true : false;
    //                 let cryptid = isSuccessful ? {
    //                   name:tx.details.targetCard.card.name,
    //                   level:{value:tx.details.targetCard.level.value + 1},
    //                   type:tx.details.targetCard.card.cryptidType,
    //                   rarity:tx.details.targetCard.card.rarity,
    //                   weakness:tx.details.targetCard.card.weaknessType,
    //                   miningPower:tx.details.upgradedCard.miningPower,
    //                   imageUri:tx.details.targetCard.card.imageUri
    //                 } : targetCard;
    //                 openUpgradeResultModal(cryptid,isSuccessful);

    //             } else if (attempts >= maxTry) {
    //                 clearInterval(pollingInterval);
    //                 setIsLoading(false);
    //                 alert("Your transaction added to que but it is not confirmed yet. Please check your transaction status later.");
    //                 navigate("/transactions");
    //             }
    //         } catch (error) {
    //             setIsLoading(false);
    //             alert("Transaction check error");
    //             clearInterval(pollingInterval);
    //             console.error("Transaction check error:", error);
    //         }
    //     }, interval);
    // };
    // const toNano = (amount) => {
    //     return (Number(amount) * 1e9).toString();
    // };
    // const prepareBody = (data) => {
    // const forwardPayload = beginCell()
    //     .storeUint(0, 32) // 0 opcode means we have a comment
    //     .storeStringTail(data.invoiceId) // write our text comment')
    //     .endCell();

    // const body = beginCell()
    //     .storeUint(0xf8a7ea5, 32) // opcode for jetton transfer
    //     .storeUint(Date.now(), 64) // query id
    //     .storeCoins(toNano(data.details.payAmount)) // Jetton amount for transfer (decimals = 6 - USDT, 9 - default). Function toNano use decimals = 9 (remember it)
    //     .storeAddress(Address.parse(depositAddress)) // TON wallet destination address
    //     .storeAddress(Address.parse(depositAddress)) // response excess destination
    //     .storeBit(0) // no custom payload
    //     .storeCoins("1") // forward amount (if >0, will send notification message)
    //     .storeBit(1) // we store forwardPayload as a reference
    //     .storeRef(forwardPayload)
    //     .endCell();

    // return body;
    // };

    // const sendTransaction = async (data) => {
    //   if(!destinationAddress) {
    //     alert("Destination address is not found Please check your wallet connection");
    //     return;
    // };

    //   setIsLoading(true);
    // const body = prepareBody(data);
    // try {
    //     const messages = {
    //         address: destinationAddress, //connectedUser jetton address
    //         amount: toNano("0.05"),
    //         payload: body.toBoc().toString("base64"),
    //     };
    //     const transactionData = {
    //         validUntil: Date.now() + 5 * 60 * 1000,
    //         messages: [messages],
    //     };
    //     const result = await tonConnectUI.sendTransaction(transactionData);

    //     if (result) {
    //         setTransactionConfirmed(true);
    //         startPolling();
    //     }
    // } catch (error) {
    //     clearInterval();
    //     setIsLoading(false);
    //     alert("Transaction request error");
    //     console.error('Transaction error:', error);
    // }
    // };
    const openSelectItemModal = () =>{
      if(!targetCard){
        alert("Please select target card");
        return;
      }
      if(materialCards.length < 4){
        alert("Please select 4 material cards");
        return;
      }

      let items = enhancers.filter(item => item.item.usableRarity === targetCard.rarity._id);
      openSheet({content:<SelectInventoryItemModalContent items={items} onSelect={handleEnhancerSelection} />,title:"Select Enhancer"})}

  const getEnhancers = async () => {
    setIsLoading(true);
    const response = await getInventory();
    if (!response?.success) {
        setIsLoading(false);
        return;
    }
    setEnhancers(response.data.filter(item => item.itemType === "Enhancer" && !item.used));
    setIsLoading(false);
  }
  useEffect(() => {
    getEnhancers();
  }, []);
  const handleEnhancerSelection = (item) => {
    setSelectedEnhancer(item);
    const {cost,successRate,roi} = calculateUpgradeDetails(targetCard);

    setSuccessRate(item.item.boostRate * 100 + successRate);
    closeSheet();
  }
  return (
    <ScrollableContainer>
      <ProgressContainer>
        <h3>
          Success Rate : <span>{successRate}</span>
        </h3>
        <ProgressBar
          barStyle={{ border: "none" }}
          wrapperStyle={{
            border: "none",
            maxWidth: "calc(60 * var(--vw))",
            background: "#16273D",
            boxShadow: "0px 4px 4px 0px #00000040 inset",
          }}
          progress={successRate}
        />
      </ProgressContainer>
      <UpgraderTop>
        <FlexContainer gap="8px" flexdirection="column">
          <DeckCardTitle>Target</DeckCardTitle>
          <DeckCard card={targetCard} clickAction={()=>openCryptidSelectModal(cards,onTargetCardSelect)} containerStyle={{maxWidth:"118px"}} />
        </FlexContainer>
        <Seperator src={UpgradeSeperator} style={!targetCard ? {animation: "none"}: {} } alt="Seperator" />
        <FlexContainer gap="8px" flexdirection="column">
          <DeckCardTitle filled>Roi +{roi}%</DeckCardTitle>
          <DeckCard
          card={targetCard?.level ? {...targetCard,level:{...targetCard.level,value:targetCard.level.value + 1}} : null}
          containerStyle={{maxWidth:"118px"}}/>
        </FlexContainer>
      </UpgraderTop>
      <UpgraderMiddle>
        <h3>Material Cards</h3>
        <FlexContainer style={{flexBasis:"1 1 25%"}} gap="8px">
            {MaterialCards}
        </FlexContainer>
        <FlexContainer style={{width:"fit-content"}} gap="8px">
            <span>Enhancer:</span>
          <SelectedEnhancerContainer onClick={openSelectItemModal} show={selectedEnhancer}>
          <img src={selectedEnhancer?.item.imageUri} alt={selectedEnhancer?.item.name} />
          <span>{selectedEnhancer?.item.name}</span>
        </SelectedEnhancerContainer>
            {/* <img style={{maxWidth:"32px"}} src={NovaLogo} alt="Nova Logo" />
            <span>{cost} NOVA ≈$0</span> */}
        </FlexContainer>
        <PrimaryButton onClick={selectedEnhancer ?  handleUpgrade : openSelectItemModal} style={{maxWidth:"60%"}}>{selectedEnhancer ? "Upgrade" : "Select Enhancer"}</PrimaryButton>
      </UpgraderMiddle>
    </ScrollableContainer>
  );
};

const ProgressContainer = styled(FlexContainer)`
  flex-direction: column;
  margin-top: 16px;
  gap: 8px;
  margin-bottom: 16px;
  h3 {
    font-size: 1.2em;
    font-weight: 500;
    span {
      font-weight: 800;
    }
  }
`;
const UpgraderTop = styled(FlexContainer)`
  flex: 1 1 45%;
  padding: 0 32px;
  margin-bottom: 16px;
`;
const Seperator = styled.img`
  max-width: 30px;
  width: 100%;
  margin-top: 15%;
  animation: ${pulseRight} 1.5s ease-in-out infinite
`;
const DeckCardTitle = styled.span`
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  color: ${(props) => (props.filled ? "#FFFFFF" : "rgba(255, 255, 255, 0.5)")};
  border: ${(props) =>
    props.filled ? "1px solid #FFFF" : "1px solid rgba(255, 255, 255, 0.5)"};
  border-radius: 16px;
  background: ${(props) =>
    props.filled
      ? "linear-gradient(360deg, #876BC6 0%, #7859C1 55.98%, #6E4EBB 111.96%)"
      : "transparent"};
  box-shadow: ${(props) => (props.filled ? "0px 4px 0px 0px #6747AC" : "none")};
  font-weight: ${(props) => (props.filled ? "600" : "400")};
  font-size: 1em;
`;
const UpgraderMiddle = styled(FlexContainer)`
   flex-direction: column;
   h3{
         font-size: 1.2em;
         font-weight: 500;
   }
   margin-bottom: 34px;
`;
const SelectedEnhancerContainer = styled(FlexContainer)`
  /* position: absolute; */
  display:${(props) => (props.show ? "flex" : "none")};
  right: 16px;
  cursor: pointer;
  gap: 8px;
  img{
    width: 32px;
  }
  span{
    font-size: 1em;
    color: white;
  }
`
export default Upgrader;
